import { formatText, NOT_FOUND_TRANSLATION } from 'core/i18n';
import { getMethodTextsProps } from 'components/newAccountSteps/profileSteps/profileStep3/IdentificationMethod/utilities/getMethodTextsProps';

const getSingleMethodTitles = ({ isSelectedVideoselfieWithBiometrics, identificationMethod }) => {
    const singleMethodProps = getMethodTextsProps(identificationMethod, isSelectedVideoselfieWithBiometrics);
    const singleTitleTranslation = formatText(singleMethodProps.singleTitle);
    const singleContentTranslation = formatText(singleMethodProps.singleContent);

    return [
        singleContentTranslation !== NOT_FOUND_TRANSLATION
            ? singleTitleTranslation
            : formatText(singleMethodProps.title),
        singleContentTranslation !== NOT_FOUND_TRANSLATION
            ? singleContentTranslation
            : formatText(singleMethodProps.content),
    ];
};

export default getSingleMethodTitles;
